function buildItemLink(projectId, languageCodename, itemId) {
  return "https://app.kontent.ai/goto/edit-item/project/" + projectId + "/variant-codename/" + languageCodename + "/item/" + itemId;
}
export function buildElementLink(projectId, languageCodename, itemId, elementCodename) {
  return buildItemLink(projectId, languageCodename, itemId) + "/element/" + elementCodename;
}